export enum ConditionOperator {
	And = 1,
	Or = 2,
	Any = 3,
	Exact = 4,
}
